import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

export default class ToastHandler{

    constructor() {
    }

    showToast(text){
        Toastify({
            text: text,
            duration: 5000,
            close: true,
            gravity: "top", // `top` or `bottom`
            position: 'center', // `left`, `center` or `right`
            backgroundColor: "#4399d4",
            stopOnFocus: true, // Prevents dismissing of toast on hover
            className: "toast",
            onClick: function(){} // Callback after click
        }).showToast();
    }

}